module.exports = __webpack_public_path__ + "img/PG1_1-4-259x195.e688380d.png";